import { render, staticRenderFns } from "./task-management.vue?vue&type=template&id=f303c21e&scoped=true"
import script from "./task-management.vue?vue&type=script&lang=js"
export * from "./task-management.vue?vue&type=script&lang=js"
import style0 from "./task-management.vue?vue&type=style&index=0&id=f303c21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f303c21e",
  null
  
)

export default component.exports